import type { AnalyticsClient } from '@/scopes/common/domain/types'
import { AbTestData } from '@/scopes/common/infrastructure/ab-testing/edge-function/types'
import ga4analyticsClient from '@/scopes/common/infrastructure/analytics/ga4analyticsClient'

export interface CommonAnalyticsClient {
  sendAbVariantEvent: (payload: AbTestData) => void
}

export function createGa4CommonAnalyticsClient({
  analyticsClient = ga4analyticsClient,
}: {
  analyticsClient?: AnalyticsClient
}): CommonAnalyticsClient {
  function sendAbVariantEvent({ isEnabled, isBVariant }: AbTestData) {
    if (!isEnabled) {
      return
    }

    const result = isBVariant ? 'Variant' : 'Default'
    analyticsClient.sendEvent(
      {
        event: 'CRO',
        description: 'ID 435a | PDP| informative header section ',
        element: 'NL',
        type: 'Flag',
        result,
        interaction: false,
      },
    )
  }

  return {
    sendAbVariantEvent,
  }
}

export default createGa4CommonAnalyticsClient({})
